module.exports = __webpack_public_path__ + "5a6f3133f4624d784dd86730b492885f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/summary-diamond-placeholder@2x.png
// module id = 763
// module chunks = 0